module.exports = __webpack_public_path__ + "static/media/dice-four.26ced0db.svg";